/**
 * Modern Shadow System for PACS Application
 * Subtle, layered shadows for depth without being heavy
 */

// Custom shadow scale
export const shadowTokens = {
  none: 'none',
  xs: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)',
  inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.05)',
  // Colored shadows for elevation
  primary: '0 4px 14px 0 rgb(105 203 249 / 0.3)',
  accent: '0 4px 14px 0 rgb(38 186 255 / 0.3)',
  error: '0 4px 14px 0 rgb(239 68 68 / 0.3)',
  success: '0 4px 14px 0 rgb(16 185 129 / 0.3)',
};

// Dark mode shadows (more subtle)
export const darkShadowTokens = {
  none: 'none',
  xs: '0 1px 2px 0 rgb(0 0 0 / 0.3)',
  sm: '0 1px 3px 0 rgb(0 0 0 / 0.4), 0 1px 2px -1px rgb(0 0 0 / 0.4)',
  md: '0 4px 6px -1px rgb(0 0 0 / 0.4), 0 2px 4px -2px rgb(0 0 0 / 0.4)',
  lg: '0 10px 15px -3px rgb(0 0 0 / 0.4), 0 4px 6px -4px rgb(0 0 0 / 0.4)',
  xl: '0 20px 25px -5px rgb(0 0 0 / 0.5), 0 8px 10px -6px rgb(0 0 0 / 0.5)',
  '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.6)',
  inner: 'inset 0 2px 4px 0 rgb(0 0 0 / 0.3)',
  primary: '0 4px 14px 0 rgb(105 203 249 / 0.2)',
  accent: '0 4px 14px 0 rgb(38 186 255 / 0.2)',
  error: '0 4px 14px 0 rgb(239 68 68 / 0.2)',
  success: '0 4px 14px 0 rgb(16 185 129 / 0.2)',
};

// MUI shadows array (0-24)
// Using our custom shadows mapped to MUI's elevation system
const createMuiShadows = (tokens) => [
  tokens.none,                    // 0
  tokens.xs,                      // 1
  tokens.sm,                      // 2
  tokens.sm,                      // 3
  tokens.md,                      // 4
  tokens.md,                      // 5
  tokens.md,                      // 6
  tokens.md,                      // 7
  tokens.lg,                      // 8
  tokens.lg,                      // 9
  tokens.lg,                      // 10
  tokens.lg,                      // 11
  tokens.lg,                      // 12
  tokens.lg,                      // 13
  tokens.lg,                      // 14
  tokens.lg,                      // 15
  tokens.xl,                      // 16
  tokens.xl,                      // 17
  tokens.xl,                      // 18
  tokens.xl,                      // 19
  tokens.xl,                      // 20
  tokens.xl,                      // 21
  tokens.xl,                      // 22
  tokens.xl,                      // 23
  tokens['2xl'],                  // 24
];

export const lightShadows = createMuiShadows(shadowTokens);
export const darkShadows = createMuiShadows(darkShadowTokens);

// Default export
export default lightShadows;
